import {DateTime} from 'luxon';
/**
 * @param {Date} firstDate Date in ISO format
 * @param {Date} secondDate Date in ISO format
 * @returns Date array sorted in descending order
 */
export default function sortByDate(firstDate, secondDate) {
	return DateTime.fromISO(secondDate) - DateTime.fromISO(firstDate);
}
